export const getSortIcon = (type, query) => {
  if (type === query.sortBy) {
    if (query.sortOrder === 'asc') {
      return 'sortTop';
    }

    if (query.sortOrder === 'desc') {
      return 'sortBottom';
    }
  }

  return 'sort';
};